export interface GeoData {
  country: string;
  country_code: string;
  city: string;
  currency: string;
}

export const fetchGeoData = async (): Promise<GeoData | null> => {
  try {
    const baseURL =
      "https://socialmediawebappdotnet-c5gvgzgqauekgmej.westindia-01.azurewebsites.net";
    const res = await fetch(baseURL + "/api/ipinfo/log", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        screenWidth: window.innerWidth,
        screenHeight: window.innerHeight,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        languages: navigator.languages,
        cookieEnabled: navigator.cookieEnabled,
        online: navigator.onLine,
        devicePixelRatio: window.devicePixelRatio,
        language: navigator.language,
        platform: navigator.platform,
        hardwareConcurrency: navigator.hardwareConcurrency,
        maxTouchPoints: navigator.maxTouchPoints,
        referrer: document.referrer,
        currentUrl: window.location.href,
      }),
    });
    if (!res.ok) {
      return null;
    }

    const data = await res.json();
    //alert(JSON.stringify(data, null, 2));
    console.log("Geo response:", data);
    return {
      country: data.country,
      country_code: data.country_code,
      city: data.city,
      currency: data.currency,
    };
  } catch (error) {
    console.error("Geo fetch failed", error);
    return null;
  }
};
